import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  selectPrinter: {
    description: 'scanToPrint.printerDropdown.selectPrinter',
    defaultMessage: 'Select a Printer',
    id: '0LdMI+',
  },
  printerPrefix: {
    description: 'scanToPrint.printerDropdown.printerPrefix',
    defaultMessage: 'Printer',
    id: 'N25soG',
  },
});
